const STORY_IMG =
  "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://storage.googleapis.com/msgsndr/UL9GAEU0ONW7drLQGkjG/media/6882c2f653c8441d20d464da.jpeg";

const PILLARS = [
  {
    n: "I",
    title: "Cellular medicine",
    body: "PEMF and red light reach the mitochondria — the engine room of every cell — to restore the energy production that aging quietly steals.",
  },
  {
    n: "II",
    title: "Pressurized recovery",
    body: "HBOT floods tissue with oxygen at 1.3 ATA, accelerating healing, calming inflammation, and waking up dormant stem cells.",
  },
  {
    n: "III",
    title: "Island nervous system",
    body: "A phone-free, low-light, low-noise lounge. The therapies do the chemistry; Haiku does the rest.",
  },
];

export default function Story() {
  return (
    <section
      data-testid="story-section"
      className="relative bg-bone py-24 sm:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-6 mll-reveal">
            <div className="mll-zoom relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={STORY_IMG}
                alt="A long, healthy life on Maui"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-bone/90 backdrop-blur px-5 py-4">
                <p className="text-[10px] uppercase tracking-[0.28em] font-semibold text-clay">
                  The Lounge Philosophy
                </p>
                <p className="font-serif italic text-stone text-lg mt-1">
                  &ldquo;Longevity is built quietly, daily, deliberately.&rdquo;
                </p>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-6 mll-stagger">
            <p className="text-[11px] uppercase tracking-[0.28em] font-semibold text-clay">
              The formula
            </p>
            <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl lg:text-[56px] tracking-tight text-stone leading-[1.05]">
              A clinical lounge,{" "}
              <em className="italic font-normal text-jungle">
                tuned to the way the body actually heals.
              </em>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-muted-ink leading-relaxed max-w-xl">
              The science of longevity is no longer a hypothesis — it is a
              protocol. We&rsquo;ve assembled the four modalities with the
              strongest body of clinical evidence, and built a quiet space
              around them where the parasympathetic system can finally take
              over.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 border-t border-sand pt-10">
              {PILLARS.map((p) => (
                <div key={p.n}>
                  <p className="font-serif italic text-clay text-2xl">
                    {p.n}
                  </p>
                  <h4 className="mt-3 font-serif text-xl text-stone">
                    {p.title}
                  </h4>
                  <p className="mt-2 text-sm text-muted-ink leading-relaxed">
                    {p.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
